@if (reviews().length) {
<section class="py-16 bg-sky-light fullwidth-section">
  <div class="app-container container-xl container-xl-max-md ">
    <div class="text-center mb-12">
      <h2 class="fs-2hx fw-bold mb-0">{{ "APP.STUDENT_REVIEWS" | translate }}</h2>
    </div>

    <!-- A grid, not a carousel. Three quotes visible at once say "people use
         this"; one giant rotating card says "we could only find one". -->
    <div class="row row-cols-1 row-cols-md-3 g-6" data-testid="testimonials">
      @for (item of reviews(); track item.id; let i = $index) {
      @if(i+1 <= 6){ <div class="col d-flex">
        <div class="card quote-card flex-1">
          <div class="card-body d-flex flex-column">
            <!-- The mark, not a decoration: it tells you at a glance that the
                     grey block under it is somebody's words rather than ours. Set
                     large and pale so it frames the quote instead of shouting over
                     it. -->
            <span class="quote-card__mark" aria-hidden="true">”</span>

            <!-- <div class="quote-card__stars mb-4" aria-hidden="true">★★★★★</div> -->
            <app-rating-star class="mb-4" [rating]="item.score || 0" iconSize="fs-7" gapMargin="1"></app-rating-star>
            <p class="quote-card__body flex-grow-1 mb-6">{{ item.review }}</p>

            <div class="d-flex align-items-center gap-4 quote-card__by">
              <!-- A monogram rather than the seeded glyph avatars: those ship
                       in six hues, half of them outside this palette, and six
                       identical clip-art silhouettes across a page read as stock.
                       One letter in the brand tint is the same information and
                       belongs to the design. -->
              <span class="quote-card__monogram">{{ monogram(item) }}</span>
              <div class="d-flex flex-column">
                <span class="fw-bold text-gray-900">{{ name(item) }}</span>
                @if (educated(item)) {
                <span class="fs-8 text-gray-500">{{ educated(item) }}</span>
                }
              </div>
            </div>
          </div>
        </div>
    </div>
    }
    }
  </div>
  </div>
</section>
}